/* eslint-disable camelcase */
/* eslint-env browser */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { setHeader } from 'actions';
// import has from 'lodash/has';

import Loading from 'components/common/Loading';
import Icon from 'components/common/Icon';

class AccountPage extends PureComponent {
  componentWillMount() {
    this.props.setHeader('My Account');
  }

  render() {
    const { auth } = this.props;

    if (!auth || auth.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    if (!auth.auth_token || !auth.data)
    {
      return (
        <div className="account-page">
         <p>Not currently signed in.  <Link to="/login">Sign In</Link></p>
        </div>
      );
    }

    let profileUrl = '';
    if (auth.data.picture) {
      profileUrl = `${window.API_ROOT}?type=export&action=image&export_type=db_mini&id=${auth.data.picture}`;
    } else if (auth.data.facebook_uid) {
      profileUrl = `https://graph.facebook.com/${auth.data.facebook_uid}/picture?width=256&height=256`;
    }

    let profileImg;
    if(profileUrl != '') {
      profileImg = (<img src={profileUrl} alt="Profile" />);
    } else {
      profileImg = (<Icon icon="my-profile" size="xlarge" style={{width: 100, height: 100}} />);
    }

    return (
      <div className="account-page">
        {profileImg}
        <p className="name">{auth.data.first_name} {auth.data.last_name}</p>
        <p>{auth.data.email}</p>
        <p>&nbsp;</p>
        <p><a href={`${window.DESKTOP_URL}?&mobile=f`}>Switch to Desktop View</a></p>
        <p>&nbsp;</p>
        <p><Link to="/logout">Sign Out</Link></p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { auth } = state;

  return {
    auth,
  };
}

export default connect(mapStateToProps, {
  setHeader,
})(AccountPage);



// WEBPACK FOOTER //
// ./src/app/containers/AccountPage.js